const WEB_APP_BASE = 'https://app.tenkusports.com';

const WEB_PATH_RE = /^(tournaments|games|community\/teams)\/[^/]+$/;

export function webAppInviteUrl(token) {
  return `${WEB_APP_BASE}/i/${encodeURIComponent(token || '')}`;
}

export function webAppVenueUrl(slug) {
  return `${WEB_APP_BASE}/l/${encodeURIComponent(slug || '')}`;
}

export function webAppUrlForPath(path) {
  if (!path || path === 'home') return WEB_APP_BASE;
  return WEB_PATH_RE.test(path) ? `${WEB_APP_BASE}/${path}` : null;
}
